export const TOP_UP_HISTORY_TITLE = [
  { text: 'Date', value: 'createdAt' },
  { text: 'Recipient Name', value: 'recipientName' },
  { text: 'Prev. Credit.', value: 'creditBefore' },
  { text: 'Top Up Amt.', value: 'credit' },
  { text: 'Current Credit', value: 'creditAfter' },
];
